<template>
  <div class="search-part">
    <!-- role="search" 声明这是一个搜索区域，iOS 的 VoiceOver 可以通过“转子”快速跳转到搜索区域 -->
    <!-- class="mod-search-bar" position:relative
        class="mod-search-bar_fixed" position:fixed
        class="mod-search-bar_active"  显示input框
        class="mod-search-bar_trans-style"  背景透明（首页用）-->
    <div class="mod-search-bar" v-bind:class="searchBarClass" role="search">
      <form class="mod-search-bar__form" action="" @submit.prevent="searchSubmit()">
        <div class="mod-search-bar__box">
          <svg aria-hidden="true" class="mod-icon-search" width="25" height="25" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M17.7356 16.322L25 23.5863 23.5864 25l-7.2645-7.2644c-1.7232 1.41-3.926 2.256-6.3262 2.256C4.4753 19.9917 0 15.5165 0 9.996 0 4.4753 4.4753 0 9.9958 0c5.5206 0 9.996 4.4753 9.996 9.9958 0 2.4003-.846 4.603-2.2562 6.326zm-7.7398 1.6705c4.4165 0 7.9967-3.5802 7.9967-7.9967 0-4.4164-3.5802-7.9966-7.9967-7.9966-4.4164 0-7.9966 3.5802-7.9966 7.9966 0 4.4165 3.5802 7.9967 7.9966 7.9967z"
              fill="#B2B2B2"
              fill-rule="evenodd"
            />
          </svg>
          <input
            type="search"
            id="searchInput"
            class="mod-search-bar__input"
            v-bind:placeholder="searchPlaceHolderWord"
            v-on:input="bindInputEvent"
            v-model="searchInput"
            v-focus="inputFocus"
            @focus="onFocus"
            @blur="onBlur"
          />
          <label for="searchInput"
            ><i class="mod-icon-clear" role="button" aria-label="删除输入" v-if="searchInput !== ''" @click="clearSearchInput"></i
          ></label>
        </div>
        <label
          class="new--moudle mod-search-bar__label"
          :class="isIndex ? '' : 'mod-search-bar__label_list'"
          for="searchInput"
          @click="showSearch"
        >
          <span>
            <svg aria-hidden="true" class="mod-icon-search" width="25" height="25" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M17.7356 16.322L25 23.5863 23.5864 25l-7.2645-7.2644c-1.7232 1.41-3.926 2.256-6.3262 2.256C4.4753 19.9917 0 15.5165 0 9.996 0 4.4753 4.4753 0 9.9958 0c5.5206 0 9.996 4.4753 9.996 9.9958 0 2.4003-.846 4.603-2.2562 6.326zm-7.7398 1.6705c4.4165 0 7.9967-3.5802 7.9967-7.9967 0-4.4164-3.5802-7.9966-7.9967-7.9966-4.4164 0-7.9966 3.5802-7.9966 7.9966 0 4.4165 3.5802 7.9967 7.9966 7.9967z"
                fill="#B2B2B2"
                fill-rule="evenodd"
              />
            </svg>
            {{ searchLabelWord }}
          </span>
        </label>
      </form>
      <a role="button" id="cancal-btn" class="mod-search-bar__cancel-btn" @click="cancelSearch()">取消</a>
    </div>
    <!-- 搜索结果层 -->
    <div class="search-bd">
      <div class="mod-search__display" v-if="showSearchPage" style="z-index: 99">
        <!-- Loading -->
        <div class="mod-search__loading" v-if="showSearchLoading"><i class="weui-loading"></i></div>

        <!-- modified by sevencai 历史搜索 和 热门搜索同时出现所以用一个变量就可以了 -->
        <div class="mod-search__result" v-if="!showSearchLoading && showInitPanel && searchHistory.length && !searchInput">
          <i class="i_delete" tabindex="0" role="button" aria-label="删除历史搜索记录" @click="clearSearchHistory">
            <svg width="36" height="39" viewBox="0 0 36 39" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M27 37H9c-1.5352 0-2-.138-2-2.069S5 7 5 7h26s-1.8447 26.7665-2 27.931C28.8447 36.0956 28.5352 37 27 37zM14 4c0-1.3295.5973-2 1-2h6c.4027 0 1 .6705 1 2v1h-8V4zm10 1V3c.4286-1.8352-.7234-3-2-3h-8c-1.2766 0-2.4286 1.1648-2 3v2H3c-2 0-3 .0648-3 1 0 1 1 1 3 1l2 28c.143 2.9717 1.16 4 4 4h18c2.84 0 3.857-1.0283 4-4l2-28c2 0 3 0 3-1s-1-1-3-1h-9zm-5.6667 26c.2187 0 .6667-.5428.6667-1V15c0-.456-.448-1-.6667-1C17.448 14 17 14.544 17 15v15c0 .4572.448 1 1.3333 1zM13 30V15c0-.456-.448-1-.6667-1C11.448 14 11 14.544 11 15v15c0 .4572.448 1 1.3333 1 .2187 0 .6667-.5428.6667-1zm12 0V15c0-.456-.448-1-.6667-1C23.448 14 23 14.544 23 15v15c0 .4572.448 1 1.3333 1 .2187 0 .6667-.5428.6667-1z"
                fill="#3D87FD"
                fill-rule="evenodd"
              />
            </svg>
          </i>
          <h3 class="mod-search__tit">历史搜索</h3>
          <ul class="mod-hot__list">
            <li
              class="mod-hot__item"
              role="button"
              v-for="(item, index) in searchHistory"
              v-if="item"
              :key="index"
              @click="searchSubmit(item, searchFrom === 'index' ? 'search_his' : 'service_list_search_his')"
            >
              {{ item }}
            </li>
          </ul>
          <br />
        </div>
        <!-- 热门搜索 -->
        <div class="mod-search__result" v-if="!showSearchLoading && showInitPanel && hotSearch.length && !searchInput">
          <h3 class="mod-search__tit">大家都在搜</h3>
          <ul class="mod-hot__list">
            <li
              class="mod-hot__item"
              role="button"
              v-for="(item, index) in hotSearch"
              :key="index"
              @click="searchSubmit(item.name, searchFrom === 'index' ? 'search_hot' : 'service_list_search_hot')"
            >
              {{ item.name }}
            </li>
          </ul>
          <br />
        </div>

        <!-- 搜索结果 -->
        <div class="mod-search__result" v-if="!showSearchLoading && searchResult.match && searchResult.match.length && searchInput">
          <h3 class="mod-search__tit">搜索结果</h3>
          <div class="mod-list mod-list--link">
            <div
              class="mod-list__item"
              role="button"
              v-for="(item, index) in searchResult.match"
              :key="index"
              @click="jumpToOrderPage(item)"
            >
              <div class="mod-service">
                <div class="mod-service__hd">
                  <img aria-hidden="true" class="mod-service__pic" v-bind:alt="item.name" v-bind:src="item.icon" />
                </div>
                <div class="mod-service__bd">
                  <h4 class="mod-service__name">{{ item.name }}</h4>
                  <!--<p class="mod-service__desc">{{item.description}}</p>-->
                </div>
              </div>
            </div>
          </div>
          <br />
        </div>

        <!-- 搜索结果 -->
        <div class="mod-search__result" v-if="!showSearchLoading && searchResult.recommend && searchResult.recommend.length && searchInput">
          <h3 class="mod-search__tit">搜索推荐</h3>
          <div class="mod-list mod-list--link">
            <div
              class="mod-list__item"
              role="button"
              v-for="(item, index) in searchResult.recommend"
              :key="index"
              @click="jumpToOrderPage(item)"
            >
              <div class="mod-service">
                <div class="mod-service__hd">
                  <img aria-hidden="true" class="mod-service__pic" v-bind:alt="item.name" v-bind:src="item.icon" />
                </div>
                <div class="mod-service__bd">
                  <h4 class="mod-service__name">{{ item.name }}</h4>
                  <!--<p class="mod-service__desc">{{item.description}}</p>-->
                </div>
              </div>
            </div>
          </div>
          <br />
        </div>

        <!-- 没有相关商品,此时的推荐从配置台读 -->
        <div
          class="mod-search__result"
          v-if="!showSearchLoading && !searchResult.match.length && searchInput && !searchResult.recommend.length"
        >
          <p class="mod-search__txt mod-search__txt--center">没搜到相关业务哦，请检查关键字</p>
          <!-- 你是不是想搜 -->
          <h3 class="mod-search__tit mod-search__tit--primary" v-if="searchEmptyRecommend && searchEmptyRecommend.length">你是不是想搜</h3>
          <div class="mod-ly-flex">
            <div
              class="mod-ly-flex--primary mod-service vert-style"
              role="button"
              v-for="(item, index) in searchEmptyRecommend"
              :key="index"
              @click="jumpToOrderPage(item, searchFrom === 'index' ? 'search_more' : 'service_list_search_more')"
            >
              <div class="mod-service__hd">
                <img aria-hidden="true" class="mod-service__pic" v-bind:alt="item.name" v-bind:src="item.icon" />
              </div>
              <div class="mod-service__bd">
                <h4 class="mod-service__name">{{ item.name }}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex"
import localstorage from "../../utils/localStorage"
import * as listApi from "../../api/list"
import * as storeConfigApi from "../../api/store-config"
import * as pfStructure from "../../constants/pf-structure"
import * as reportDict from "../../constants/report-dictonary"
import * as langs from "../../constants/langs"
import Raven from "raven-js"
import { getParam } from "../../utils/url"

export default {
  /**
   * 页面 mounted 的时候就设置热搜及相应的配置列表
   */
  mounted() {
    // 有参数block_search_recomm则无需显示【你是不是想搜】
    if (!getParam("block_search_recomm")) {
      listApi.getEmptyRecommendByConfig(this.storeConfig).then(res => {
        this.searchEmptyRecommend = res
      })
    }

    // 搜索推荐关键词
    this.getIndexSearchRecommend()
      .then(res => {
        // ios微信钱包、公众号入口不可显示包月，所以不显示ip推荐
        if (!storeConfigApi.checkWhiteListPf(this.pf, this.storeConfig.block_ios_app_pfs) && !getParam("block_search_recomm"))
          this.searchRecommWord = res
      })
      .catch(err => {
        Raven.captureException(new Error("search-recomm-error"), {
          tag: { type: "search-recomm-error" },
          extra: {
            data: err
          }
        })
      })
  },

  props: ["positionType", "backgroundType", "searchFrom", "storeConfig", "isIndex"],

  /**
   * 大部分数据用于控制页面状态
   */
  data() {
    return {
      inputFocus: false,
      showSearchLoading: false,
      showInitPanel: true,
      searchHistory: [],
      searchInput: "",
      searchResult: { match: [], recommend: [] },
      currentTimer: "",
      searchStructure: "",
      active: false,
      searchEmptyRecommend: [],
      searchRecommWord: ""
    }
  },

  /**
   * 样式列表或者是从配置台读的 TOP4 业务
   */
  computed: {
    ...mapGetters(["loginState", "isPfFromWechatWallet", "userAgent", "pf"]),
    ...mapState({
      hotSearch: ({ search }) => search.hotSearch,
      showSearchPage: ({ search }) => search.showSearchPage
    }),
    searchBarClass() {
      return {
        "mod-search-bar_active": this.showSearchPage,
        "mod-search-bar_fixed": this.positionType === "fixed" || this.showSearchPage,
        "mod-search-bar_trans-style": this.backgroundType === "transparent" && !this.showSearchPage
      }
    },
    isIosQQ() {
      return this.userAgent.iOS && this.userAgent.QQ
    },
    searchPlaceHolderWord() {
      return this.searchRecommWord ? this.searchRecommWord : this.isPfFromWechatWallet ? "搜“游戏名称”、“会员名称”" : "搜一搜"
    },
    // qq和微信入口搜索显示:搜“游戏名称”、“会员名称”,其他入口显示 搜一搜
    // 增加了ip以后：
    // qq和微信入口搜索显示:    搜“游戏名称”、“会员名称”、“ip”,其他入口显示 搜“搜一搜 如IP”
    searchLabelWord() {
      let word = "搜一搜"
      if (this.isPfFromWechatWallet) {
        word = "搜“游戏名称”、“会员名称”"
        if (this.searchRecommWord) {
          word = `搜“游戏名称”、“会员名称”、“${this.searchRecommWord}”`
        }
      } else {
        word = "搜一搜"
        if (this.searchRecommWord) {
          word = `搜一搜 如“${this.searchRecommWord}”`
        }
      }
      return word
    }
  },

  /**
   *  大部分是页面控制函数
   *  部分是 view dispatch actions
   */
  methods: {
    ...mapActions([
      "getKeywordSearchRecommend",
      "getKeyWordSearchServices",
      "reportUserAction",
      "setSearchPageStatus",
      "goToOrderPage",
      "getIndexSearchRecommend"
    ]),

    // 在 ios&qq 上时，当focus的时候隐藏首页，来避免首页也会被展示出来的bug
    onFocus() {
      this.inputFocus = true
    },

    // 当 onblur 时，再把首页展示出来
    onBlur() {
      this.inputFocus = false
    },

    // 点击搜索框，展开搜索页
    showSearch() {
      this.setSearchPageStatus(true)

      this.getSearchHistory()

      this.reportTotalFormat(reportDict.CLICK.SEARCH_INPUT_FOCUS)
    },

    // 点击'取消'，隐藏搜索页
    cancelSearch() {
      this.clearSearchInput(false)
      this.setSearchPageStatus(false)

      this.reportTotalFormat(reportDict.CLICK.CANCEL_SEARCH)
    },

    // 清空输入框, 这里的 flag 是为了防止点击取消的时候调用此函数还会上报
    clearSearchInput(flag = true) {
      this.searchInput = ""
      this.searchResult = { match: [], recommend: [] }

      if (flag) {
        this.reportTotalFormat(reportDict.CLICK.CLEAR_SEARCH_INPUT)
      }
    },

    // 历史搜索 !notice 此处需要加 if 判断，原来的写法会导致每次每次都读缓存
    getSearchHistory() {
      if (!this.searchHistory.length) {
        this.searchHistory = localstorage.get("searchHistory", true) || []
      }
    },

    // 只要输入了就设置当前搜索的来源为 search
    bindInputEvent() {
      if (this.searchFrom !== "index") {
        this.searchStructure = pfStructure.SEARCH_LIST
        return
      }
      this.searchStructure = pfStructure.SEARCH
    },

    // 清空历史记录
    clearSearchHistory() {
      localstorage.del("searchHistory")
      this.searchHistory = []

      this.reportTotalFormat(reportDict.CLICK.CLEAR_HIS_SEARCH)
    },

    // 添加历史记录
    addSearchHistory(searchInput) {
      if (!searchInput) return

      if (this.searchHistory.indexOf(searchInput) === -1) {
        if (this.searchHistory.length >= langs.MAX_SEARCH_HISTORY_CAPACITY) {
          this.searchHistory.pop()
        }
        this.searchHistory.unshift(searchInput)
      } else {
        let num = this.searchHistory.indexOf(searchInput)
        this.searchHistory.splice(num, 1)
        this.searchHistory.unshift(searchInput)
      }
      localstorage.set("searchHistory", JSON.stringify(this.searchHistory))
    },

    // 根据来源 props 拼接 format
    reportTotalFormat(baseFormat) {
      let resultInfo = this.searchInput ? `keyword=${this.searchInput}` : ""

      this.reportUserAction({
        iformat: `${baseFormat}.${this.searchFrom}`,
        resultInfo: resultInfo
      })
    },

    /**
     * 1. 设置请求 cgi 延迟，0.5s 后再去请求
     * 2. 接搜索推荐
     */
    getSearchResult() {
      if (!this.searchInput) {
        return
      }

      this.showSearchLoading = true
      this.currentTimer && clearTimeout(this.currentTimer)

      this.currentTimer = setTimeout(() => {
        // 过滤搜索关键字，过滤页数字符，只保留中文数字和英文
        let searchInputText = this.searchInput.replace(/[^(a-zA-Z0-9\u4e00-\u9fa5)]/g, "")
        this.getKeyWordSearchServices(searchInputText)
          .then(res => {
            this.searchResult = res
            this.showSearchLoading = false
          })
          .catch(err => {
            Raven.captureException(new Error("search-keyword-error"), {
              tag: { type: "search-keyword-error" },
              extra: {
                data: err,
                keyword: this.searchInput
              }
            })
          })
      }, 500)
    },

    // 从热搜或者历史记录进入搜索
    searchSubmit(item, searchStructure = "") {
      this.inputFocus = false
      this.searchStructure = searchStructure

      if (item) {
        this.searchInput = item
      } else if (!this.searchInput && this.searchRecommWord) {
        // 当没有输入搜索内容 且 有推荐搜索时
        this.searchInput = this.searchRecommWord
      }
      this.addSearchHistory(item || this.searchRecommWord)

      this.reportTotalFormat(this.searchStructure)
    },

    /**
     * 跳转到订单页（搜索结果和你是不是想搜会经过此函数）
     * 产品策略调整 add history 的内容为 searchInput 而不是 item
     * @param item
     * @param searchStructure
     */
    jumpToOrderPage(item, searchStructure = "") {
      if (searchStructure) {
        this.searchStructure = searchStructure
        this.reportTotalFormat(reportDict.CLICK.SEARCH_MORE)
      } else {
        this.reportTotalFormat(reportDict.CLICK.SEARCH_ASSOCIATE)
      }

      this.addSearchHistory(this.searchInput)
      this.active = true

      this.goToOrderPage({
        groupId: item.groupId,
        busId: item.busId,
        query: {
          pfStructure: this.searchStructure
        }
      })
    }
  },
  directives: {
    focus: {
      componentUpdated: function(el, binding) {
        if (binding.value) {
          el.focus()
        } else {
          el.blur()
        }
      }
    }
  },
  watch: {
    searchInput() {
      if (this.searchInput === "") {
        this.getSearchHistory()
        this.showInitPanel = true
      } else {
        this.getSearchResult()
        this.showInitPanel = false
      }
    }
  }
}
</script>
